import { http } from "../../common/http";
import { InteriorCleaningParam } from "./interiorCleaning.param";

class InteriorCleaningService {
	list = async (params:InteriorCleaningParam) => {
		return http({ method: "GET", url: process.env.REACT_APP_ADMIN_API + `/order/innerClean`, params });
	};
}
export default new InteriorCleaningService();
